// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-hidden {
  display: none;
}

.header-container {
  position: absolute;
  left: 0;
  top: 20px;
  width: 100%;
  height: 100% !important;
  padding: 5% !important;
  font-size: 12px;
}
@media (max-width: 768px) {
  .header-container {
    display: none;
  }
}
@media (max-width: 480px) {
  .header-container {
    padding: 2%;
  }
}

.header-title {
  line-height: 1.3 !important;
  text-align: center;
}
@media (max-width: 480px) {
  .header-title h2 {
    font-size: 1.5rem;
  }
}
@media (max-width: 480px) {
  .header-title p {
    font-size: 0.8rem;
  }
}

.header-menu {
  margin-top: 5rem;
}
@media (max-width: 768px) {
  .header-menu {
    display: none;
  }
}

.header-menu-item {
  padding: 10px 15px;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  color: #000000;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  margin-right: -6%;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
@media (max-width: 768px) {
  .header-menu-item {
    padding: 8px 12px;
    font-size: 14px;
    margin-right: -4%;
  }
}
@media (max-width: 480px) {
  .header-menu-item {
    padding: 6px 10px;
    font-size: 12px;
    margin-right: -2%;
  }
}

.header-menu-item.active {
  background-color: #ffffff;
}

.header-link {
  text-decoration: none;
}
@media (max-width: 480px) {
  .header-link {
    font-size: 0.9rem;
  }
}

.header-link.active {
  color: #000000;
}

.header-link.inactive {
  color: #ffffff;
}

.header-bottom {
  position: absolute;
  bottom: 5%;
  text-align: center;
  width: 90%;
}
@media (max-width: 768px) {
  .header-bottom {
    width: 100%;
  }
}

.header-vacation-info {
  text-align: center;
  margin-top: 2rem;
}
@media (max-width: 768px) {
  .header-vacation-info {
    margin-top: 1.5rem;
  }
}
@media (max-width: 480px) {
  .header-vacation-info {
    margin-top: 1rem;
  }
}

.header-vacation-title {
  text-transform: uppercase;
}
@media (max-width: 480px) {
  .header-vacation-title {
    font-size: 1rem;
  }
}

.header-vacation-list {
  text-align: center;
  margin-top: 1rem;
}
@media (max-width: 480px) {
  .header-vacation-list {
    margin-top: 0.5rem;
  }
}
.header-vacation-list div {
  font-size: 0.9rem;
}
@media (max-width: 480px) {
  .header-vacation-list div {
    font-size: 0.8rem;
  }
}

.header-user-info {
  text-align: center;
  margin-top: 2rem;
  padding-bottom: 5% !important;
}
@media (max-width: 768px) {
  .header-user-info {
    margin-top: 1.5rem;
  }
}
@media (max-width: 480px) {
  .header-user-info {
    margin-top: 1rem;
  }
}
@media (max-width: 480px) {
  .header-user-info h3 {
    font-size: 1.2rem;
  }
}

.logout-button {
  border-radius: 20px;
  padding: 0 30px;
}
@media (max-width: 480px) {
  .logout-button {
    padding: 0 20px;
    font-size: 0.9rem;
  }
}

.hamburger {
  display: none;
}
@media (max-width: 768px) {
  .hamburger {
    display: block;
    position: fixed;
    top: 10px;
    right: 30px;
    cursor: pointer;
    z-index: 1002;
    width: 30px;
    height: 30px;
  }
}
.hamburger div {
  width: 100%;
  height: 4px;
  background-color: #fff;
  margin: 6px 0;
  transition: 0.4s;
}
.hamburger.open div:nth-child(1) {
  transform: rotate(-45deg) translate(-5px, 6px);
}
.hamburger.open div:nth-child(2) {
  opacity: 0;
}
.hamburger.open div:nth-child(3) {
  transform: rotate(45deg) translate(-5px, -6px);
}

.mobile-menu {
  display: none;
}
@media (max-width: 768px) {
  .mobile-menu {
    position: fixed;
    top: 55px;
    left: 0;
    width: 100%;
    height: calc(100% - 55px);
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 1000;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transform: translateY(-100%);
    transition: transform 0.3s ease-in-out;
  }
}
.mobile-menu.open {
  display: block;
  transform: translateY(0);
}
.mobile-menu ul {
  list-style: none;
  padding: 0;
}
.mobile-menu ul li {
  margin: 1.5rem 0;
}
.mobile-menu ul a {
  text-decoration: none;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
}

.mobile-user-info {
  text-align: center;
  width: 75%;
  position: absolute;
  bottom: 15%;
}
.mobile-user-info .header-vacation-info {
  margin-bottom: 1.5rem;
}
.mobile-user-info .header-user-info {
  margin-bottom: 1.5rem;
}
.mobile-user-info .header-user-info h3 {
  font-size: 1.2rem;
}
.mobile-user-info .logout-button {
  padding: 0.5rem 2rem;
  font-size: 1rem;
  border-radius: 20px;
}`, "",{"version":3,"sources":["webpack://./src/styles/header.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;AAFJ;AAGI;EARJ;IASQ,aAAA;EAAN;AACF;AACI;EAXJ;IAYQ,WAAA;EAEN;AACF;;AACA;EACI,2BAAA;EACA,kBAAA;AAEJ;AAAQ;EADJ;IAEQ,iBAAA;EAGV;AACF;AAAQ;EADJ;IAEQ,iBAAA;EAGV;AACF;;AACA;EACI,gBAAA;AAEJ;AADI;EAFJ;IAGQ,aAAA;EAIN;AACF;;AADA;EACI,kBAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,4BAAA;EACA,+BAAA;AAIJ;AAHI;EAZJ;IAaQ,iBAAA;IACA,eAAA;IACA,iBAAA;EAMN;AACF;AALI;EAjBJ;IAkBQ,iBAAA;IACA,eAAA;IACA,iBAAA;EAQN;AACF;;AALA;EACI,yBAAA;AAQJ;;AALA;EACI,qBAAA;AAQJ;AAPI;EAFJ;IAGQ,iBAAA;EAUN;AACF;;AAPA;EACI,cAAA;AAUJ;;AAPA;EACI,cAAA;AAUJ;;AAPA;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AAUJ;AATI;EALJ;IAMQ,WAAA;EAYN;AACF;;AATA;EACI,kBAAA;EACA,gBAAA;AAYJ;AAXI;EAHJ;IAIQ,kBAAA;EAcN;AACF;AAbI;EANJ;IAOQ,gBAAA;EAgBN;AACF;;AAbA;EACI,yBAAA;AAgBJ;AAfI;EAFJ;IAGQ,eAAA;EAkBN;AACF;;AAfA;EACI,kBAAA;EACA,gBAAA;AAkBJ;AAjBI;EAHJ;IAIQ,kBAAA;EAoBN;AACF;AAnBI;EACI,iBAAA;AAqBR;AApBQ;EAFJ;IAGQ,iBAAA;EAuBV;AACF;;AAnBA;EACI,kBAAA;EACA,gBAAA;EACA,6BAAA;AAsBJ;AArBI;EAJJ;IAKQ,kBAAA;EAwBN;AACF;AAvBI;EAPJ;IAQQ,gBAAA;EA0BN;AACF;AAxBQ;EADJ;IAEQ,iBAAA;EA2BV;AACF;;AAvBA;EACI,mBAAA;EACA,eAAA;AA0BJ;AAzBI;EAHJ;IAIQ,eAAA;IACA,iBAAA;EA4BN;AACF;;AAxBA;EACI,aAAA;AA2BJ;AA1BI;EAFJ;IAGQ,cAAA;IACA,eAAA;IACA,SAAA;IACA,WAAA;IACA,eAAA;IACA,aAAA;IACA,WAAA;IACA,YAAA;EA6BN;AACF;AA5BI;EACI,WAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AA8BR;AA5BI;EACI,8CAAA;AA8BR;AA5BI;EACI,UAAA;AA8BR;AA5BI;EACI,8CAAA;AA8BR;;AA1BA;EACI,aAAA;AA6BJ;AA5BI;EAFJ;IAGQ,eAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,yBAAA;IACA,oCAAA;IACA,aAAA;IACA,aAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,4BAAA;IACA,sCAAA;EA+BN;AACF;AA9BI;EACI,cAAA;EACA,wBAAA;AAgCR;AA9BI;EACI,gBAAA;EACA,UAAA;AAgCR;AA/BQ;EACI,gBAAA;AAiCZ;AA/BQ;EACI,qBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AAiCZ;;AA5BA;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;AA+BJ;AA9BI;EACI,qBAAA;AAgCR;AA9BI;EACI,qBAAA;AAgCR;AA/BQ;EACI,iBAAA;AAiCZ;AA9BI;EACI,oBAAA;EACA,eAAA;EACA,mBAAA;AAgCR","sourcesContent":["// Variables for screen sizes\n$mobile: 480px;\n$tablet: 768px;\n.content-hidden {\n    display: none;\n}\n\n.header-container {\n    position: absolute;\n    left: 0;\n    top: 20px;\n    width: 100%;\n    height: 100% !important;\n    padding: 5% !important;\n    font-size: 12px;\n    @media (max-width: $tablet) {\n        display: none;\n    }\n    @media (max-width: $mobile) {\n        padding: 2%;\n    }\n}\n\n.header-title {\n    line-height: 1.3 !important;\n    text-align: center;\n    h2 {\n        @media (max-width: $mobile) {\n            font-size: 1.5rem;\n        }\n    }\n    p {\n        @media (max-width: $mobile) {\n            font-size: 0.8rem;\n        }\n    }\n}\n\n.header-menu {\n    margin-top: 5rem;\n    @media (max-width: $tablet) {\n        display: none;\n    }\n}\n\n.header-menu-item {\n    padding: 10px 15px;\n    cursor: pointer;\n    display: flex;\n    justify-content: flex-end;\n    color: #000000;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 22px;\n    margin-right: -6%;\n    border-top-left-radius: 20px;\n    border-bottom-left-radius: 20px;\n    @media (max-width: $tablet) {\n        padding: 8px 12px;\n        font-size: 14px;\n        margin-right: -4%;\n    }\n    @media (max-width: $mobile) {\n        padding: 6px 10px;\n        font-size: 12px;\n        margin-right: -2%;\n    }\n}\n\n.header-menu-item.active {\n    background-color: #ffffff;\n}\n\n.header-link {\n    text-decoration: none;\n    @media (max-width: $mobile) {\n        font-size: 0.9rem;\n    }\n}\n\n.header-link.active {\n    color: #000000;\n}\n\n.header-link.inactive {\n    color: #ffffff;\n}\n\n.header-bottom {\n    position: absolute;\n    bottom: 5%;\n    text-align: center;\n    width: 90%;\n    @media (max-width: $tablet) {\n        width: 100%;\n    }\n}\n\n.header-vacation-info {\n    text-align: center;\n    margin-top: 2rem;\n    @media (max-width: $tablet) {\n        margin-top: 1.5rem;\n    }\n    @media (max-width: $mobile) {\n        margin-top: 1rem;\n    }\n}\n\n.header-vacation-title {\n    text-transform: uppercase;\n    @media (max-width: $mobile) {\n        font-size: 1rem;\n    }\n}\n\n.header-vacation-list {\n    text-align: center;\n    margin-top: 1rem;\n    @media (max-width: $mobile) {\n        margin-top: 0.5rem;\n    }\n    div {\n        font-size: 0.9rem;\n        @media (max-width: $mobile) {\n            font-size: 0.8rem;\n        }\n    }\n}\n\n.header-user-info {\n    text-align: center;\n    margin-top: 2rem;\n    padding-bottom: 5% !important;\n    @media (max-width: $tablet) {\n        margin-top: 1.5rem;\n    }\n    @media (max-width: $mobile) {\n        margin-top: 1rem;\n    }\n    h3 {\n        @media (max-width: $mobile) {\n            font-size: 1.2rem;\n        }\n    }\n}\n\n.logout-button {\n    border-radius: 20px;\n    padding: 0 30px;\n    @media (max-width: $mobile) {\n        padding: 0 20px;\n        font-size: 0.9rem;\n    }\n}\n\n// Hamburger Menu styles\n.hamburger {\n    display: none;\n    @media (max-width: $tablet) {\n        display: block;\n        position: fixed;\n        top: 10px;\n        right: 30px;\n        cursor: pointer;\n        z-index: 1002;\n        width: 30px;\n        height: 30px;\n    }\n    div {\n        width: 100%;\n        height: 4px;\n        background-color: #fff;\n        margin: 6px 0;\n        transition: 0.4s;\n    }\n    &.open div:nth-child(1) {\n        transform: rotate(-45deg) translate(-5px, 6px);\n    }\n    &.open div:nth-child(2) {\n        opacity: 0;\n    }\n    &.open div:nth-child(3) {\n        transform: rotate(45deg) translate(-5px, -6px);\n    }\n}\n\n.mobile-menu {\n    display: none;\n    @media (max-width: $tablet) {\n        position: fixed;\n        top: 55px;\n        left: 0;\n        width: 100%;\n        height: calc(100% - 55px);\n        background-color: rgba(0, 0, 0, 0.9);\n        z-index: 1000;\n        padding: 2rem;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        transform: translateY(-100%);\n        transition: transform 0.3s ease-in-out;\n    }\n    &.open {\n        display: block;\n        transform: translateY(0);\n    }\n    ul {\n        list-style: none;\n        padding: 0;\n        li {\n            margin: 1.5rem 0;\n        }\n        a {\n            text-decoration: none;\n            color: #fff;\n            font-size: 24px;\n            font-weight: bold;\n        }\n    }\n}\n\n.mobile-user-info {\n    text-align: center;\n    width: 75%;\n    position: absolute;\n    bottom: 15%;\n    .header-vacation-info {\n        margin-bottom: 1.5rem;\n    }\n    .header-user-info {\n        margin-bottom: 1.5rem;\n        h3 {\n            font-size: 1.2rem;\n        }\n    }\n    .logout-button {\n        padding: 0.5rem 2rem;\n        font-size: 1rem;\n        border-radius: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
